<template>
  <div class="main__form transfer__wrapper">
    <form-layout
      :main-title="title"
      :mobile-title="mobileTitle"
      :small-title="true"
      :title="stepTitle"
      :sub-title="subTitle"
      @back="$router.push('/')"
      @submit="onSubmit"
    >
      <template #header></template>
      <template #sub-title>
        <div v-if="method === PURCHASE_METHODS.GIFT" class="transfer__form-badge">
          {{ $t('gift.badge') }}
        </div>
      </template>
      <div class="transfer__form">
        <Loader v-if="loading.length > 0" />
        <template v-if="method === PURCHASE_METHODS.TRANSFER">
          <div class="transfer__form-count">
            <p>{{ $t('transfer.available') }}</p>
            <small>{{ rbxAmount.toLocaleString('ru-RU') }} R$</small>
          </div>
          <div class="transfer__form-content">
            <div class="select">
              <p @click="selectItem(20, $event)" class="select__item">20 R$</p>
              <p @click="selectItem(60, $event)" class="select__item">60 R$</p>
              <p @click="selectItem(120, $event)" class="select__item">
                120 R$
              </p>
              <p @click="selectItem(300, $event)" class="select__item">
                300 R$
              </p>
            </div>
            <Input
              v-model="totalRobux"
              icon-text="R$"
              type="number"
              :hint="$t('transfer.minumum', { min: minToBuy })"
              :error="error.message"
              :state="error.show && error.status === false ? 'error' : 'default'"
              :placeholder="$t('transfer.robuxCount')"
              @input="validatePrice"
            />
            <promo-code-input
              v-if="isEnabledPromocode"
              class="transfer__form-promo"
              v-model="promoCode.value"
              :disabled="!totalRobux || promoCode.loading || !isEnabledPromocode"
              :status="promoCode.status"
              :error="promoCode.error"
              @input="onInputPromo"
              @apply="validatePromoInfo(promoCode.value)"
              @remove="fullPromoReset"
            />
          </div>

          <div :style="{ marginTop: 'auto' }">
            <div v-if="!isEnabledPromocode" class="transfer__form-promo-wrapper">
              <div v-if="!isEnabledPromocode" class="transfer__form-promo-switch" @click="isEnabledPromocode = true">
                {{ $t('transfer.promoSwitch') }}
              </div>
              <div v-if="!isEnabledPromocode" class="transfer__form-promo-info" @click="isShowPromocodeModal = true">
                {{ $t('transfer.promoInfo') }}
              </div>
            </div>
            <div class="transfer__form-footer">
              <div class="count">
                <p>
                  {{ $t('payment.total') }}:
                  <span class="blue">{{ totalRobuxText }} R$</span>
                </p>
                <p v-if="promoCode.bonus">
                  <span class="green">+{{ promoCode.bonus }} R$</span>
                </p>
              </div>
              <div class="total">
                <p>
                  {{ $t('payment.toPay') }}:
                  <span class="blue">
                    {{ getMoneyTotal().toFixed(2) }}
                    {{ currencyMap[$store.state.currency] }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-if="method === PURCHASE_METHODS.GIFT">
          <GiftList @updateGift="onSelectGift" :current="gift" />
        </template>
        <template v-if="method === PURCHASE_METHODS.PACKS">
          <PacksList @updatePack="onSelectPack" :current="pack" />
        </template>
      </div>
    </form-layout>
    <PromocodeModal v-if="isShowPromocodeModal" @close="isShowPromocodeModal = false" />
  </div>
</template>

<script>
import Loader from '@/components/LoaderBar/LoaderBar.vue'

import PromoCodeInput from '@/components/PromoCodeInput/PromoCodeInput.vue'
import PromoCodeMixin from '@/components/PromoCodeInput/PromoCodeMixin'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import Input from '@/components/Base/Input/Input.vue'
import PromocodeModal from '@/components/Modals/Promocode/PromocodeModal.vue'
import GiftList from '@/components/Gift/GiftList/GiftList.vue'
import PacksList from '@/components/Packs/PacksList/PacksList.vue'
import { debounce } from '@/utils/debounce'

import { PURCHASE_METHODS } from '@/utils/purchase'

import Purchase from '@/enums/Purchase'

export default {
  name: 'TransferMainForm',
  components: {
    GiftList,
    PacksList,

    Input,
    FormLayout,
    PromoCodeInput,
    Loader,
    PromocodeModal
  },
  inject: ['currencyMap'],
  mixins: [PromoCodeMixin],

  data() {
    return {
      PURCHASE_METHODS,
      totalRobux: Purchase.MIN_TO_BUY,
      totalRobuxText: Purchase.MIN_TO_BUY,
      error: {
        status: false,
        show: false,
        message: ''
      },
      loading: [],
      minToBuy: Purchase.MIN_TO_BUY,
      maxToBuy: Purchase.MAX_TO_BUY,
      isEnabledPromocode: false,
      isShowPromocodeModal: false,

      gift: {},
      pack: {}
    }
  },
  methods: {
    changeModal() {
      this.gift = {}
      if (+this.totalRobux === this.maxToBuy && this.isSuccessPromos) {
        this.error.status = false
        this.error.show = true
        this.error.message = this.$t('transfer.errors.robuxMaximun')

        return
      }
      if (this.error.show) {
        return
      }
      const promo = this.isSuccessPromos ? this.promoCode.value : null
      const bonus = this.isSuccessPromos ? this.promoCode.bonus : null
      const bonusForGamepass = this.isSuccessPromos ? this.promoCode.bonusForGamepass : null

      // Сохранение количества робуксов и суммы в валюте в store
      this.$store.commit('paymentsOrder/setRobuxAmount', Number(this.totalRobux))
      this.$store.commit('paymentsOrder/setAmount', this.getMoneyTotal())

      this.$analytics.send('purch_trans_1_calculator', {})
      this.$emit('changeModal', {
        modal: 'TransferCharacters',
        data: [this.totalRobux, this.getMoneyTotal, promo, bonus, bonusForGamepass]
      })

      if (this.promoCode.error) {
        this.fullPromoReset()
      }
    },
    getBeforeRate() {
      const rateType = {
        rub: 'rate',
        usd: 'rate_usd',
        eur: 'rate_eur'
      }

      return this.rates[rateType[this.$store.state.currency]]
    },
    getMoneyTotal() {
      return Math.ceil(Number(this.totalRobux * this.getBeforeRate()) * 100) / 100
    },
    selectItem(price, event) {
      // this.resetPromo()
      const target = event.target

      const selected = document.querySelector('.select__item.sel')
      if (selected) {
        selected.classList.remove('sel')
      }

      this.totalRobux = Number(price)
      this.totalRobuxText = Number(price)

      this.validatePrice()

      if (this.error.status === false) {
        return
      }

      target.classList.add('sel')
    },
    validatePrice(event) {
      const selected = document.querySelector('.select__item.sel')
      this.totalRobuxText = parseFloat(0)

      if (selected) {
        selected.classList.remove('sel')
      }
      if (isNaN(this.totalRobux)) {
        this.error.status = false
        this.error.show = true
        this.error.message = this.$t('transfer.errors.priceNotNumber')

        return
      } else if (this.totalRobux < this.minToBuy) {
        this.error.status = false
        this.error.show = true
        this.error.message = this.$t('transfer.errors.robuxMinimum', {
          robux: this.minToBuy
        })

        return
      } else if (!this.rbxAmount) {
        this.error.status = false
        this.error.show = true
        this.error.message = this.$t('transfer.errors.emptyBalance')

        return
      } else if (this.totalRobux > 5000) {
        this.error.status = false
        this.error.show = true
        this.error.message = this.$t('transfer.errors.robuxMaximun')

        return
      }

      this.error.status = true
      this.error.show = false
      this.error.message = ''

      if (this.totalRobux) {
        this.totalRobuxText = parseFloat(this.totalRobux)
      }
    },
    isInteger(num) {
      return (num ^ 0) === num
    },
    onSelectGift(value) {
      this.gift = value
    },
    onSelectPack(value) {
      this.pack = value
    },
    onSubmitGift() {
      if (!this.$store.state.isAuth) {
        this.$emit('submitGift', { modal: 'SignIn' })
        return
      }

      if (Number(this.gift.price[this.$store.state.currency]) > this.$store.getters.balance) {
        this.$analytics.send('purch_gift_e1_payment_insufficient', {})
        this.$emit('submitGift', { ...this.gift, needPayment: true })
        return
      }

      this.$analytics.send('purch_gift_1_card', {})
      this.$emit('submitGift', this.gift)
    },
    onSubmit() {
      if (this.method === PURCHASE_METHODS.TRANSFER) {
        if (this.error.show) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.error.message,
            type: 'error'
          })
          return
        }
        this.changeModal()
      }
      if (this.method === PURCHASE_METHODS.GIFT) {
        if (!this.gift.quantity) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('gift.errors.empty'),
            type: 'error'
          })
          return
        }

        this.onSubmitGift()
      }
      if (this.method === PURCHASE_METHODS.PACKS) {
        if (!this.pack.id) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('packs.errors.selectPack'),
            type: 'error'
          })
          return
        }

        this.$analytics.send('purch_packs_1_card', {})
        this.$emit('submitPack', this.pack)
      }
    },
    checkGetParams() {
      const { robux } = this.$route.query
      if (robux > Purchase.MIN_TO_BUY) {
        this.totalRobux = robux
        this.totalRobuxText = robux
      }
    },
    onInputPromo() {
      if (this.isSuccessPromos) {
        this.fullPromoReset()
      }
      if (this.promoCode.error) {
        this.promoCode.status = ''
        this.promoCode.error = ''
      }
      // this.validatePromoInfo(this.promoCode.value)
    },
    validatePromoInfo: debounce(function(promo, init = false) {
      return this._validatePromoInfo(promo, init)
    }, 300),

    async _validatePromoInfo(promo, init) {
      if (this.$store.state.promoCode.info.code !== promo) await this.getPromoInfo(promo)

      if (init) {
        const { min_amount: minAmount } = this.$store.state.promoCode.info

        this.isEnabledPromocode = true
        this.promoCode.value = promo
        this.totalRobux = minAmount || this.totalRobux
        this.totalRobuxText = this.totalRobux
      }

      if (this.promoCode.value) await this.applyPromo(this.promoCode.value, this.totalRobux)
    },
    async checkPromoAutocomplete() {
      const { promo } = this.$route.query || {}

      if (promo) {
        await this.validatePromoInfo(promo.toUpperCase(), true)
      }
    }
  },
  computed: {
    method() {
      return this.$store.state.purchaseMethod
    },
    isSuccessPromos() {
      return this.promoCode.status === 'success'
    },
    methodsList() {
      return {
        transfer: {
          title: this.$t('transfer.titleSmall'),
          headerTitle: this.$t('transfer.title'),
          mobileTitle: this.$t('transfer.titleMobile'),
          badge: null
        },
        gift: {
          title: this.$t('gift.titleSmall'),

          headerTitle: this.$t('gift.title'),
          mobileTitle: this.$t('gift.titleMobile'),
          badge: true
        },
        superPass: {
          title: this.$t('superPass.title'),
          headerTitle: this.$t('superPass.title'),
          badge: true
        },
        packs: {
          title: this.$t('packs.titleSmall'),
          headerTitle: this.$t('packs.title'),
          mobileTitle: this.$t('packs.titleMobile'),
          badge: true
        }
      }
    },
    title() {
      return this.methodsList[this.method].headerTitle
    },
    stepTitle() {
      const chooseMethods = [PURCHASE_METHODS.GIFT, PURCHASE_METHODS.PACKS]
      return chooseMethods.includes(this.method)
        ? this.$t('transfer.chooseNumberRobux')
        : this.$t('transfer.setNumberRobux')
    },
    mobileTitle() {
      return this.methodsList[this.method].mobileTitle
    },
    subTitle() {
      const text = `${this.$t('transfer.subTitle')}`
      return this.method === PURCHASE_METHODS.TRANSFER && text
    },
    rbxAmount() {
      return this.$store.state.rbxAmountStock
    },
    rates() {
      return this.$store.state.rates
    }
  },
  watch: {
    totalRobux(newValue, oldValue) {
      const isSame = newValue === oldValue

      if (!isSame && this.promoCode.value) {
        this.validatePromoInfo(this.promoCode.value)
      }
      // if (this.promoCode.status === 'success') {
      // this.resetPromo()
      // }
    },
    rbxAmount() {
      this.validatePrice()
    },
    method() {
      this.resetPromo()
    }
  },
  mounted() {
    this.checkPromoAutocomplete()
    this.checkGetParams()
    const hint = document.querySelector('.main__form.transfer__wrapper .hint')
    setTimeout(() => {
      if (hint) {
        if (document.body.clientWidth > 1395) hint.style.right = '0'
        if (document.body.clientWidth <= 1395) hint.style.bottom = '0'
      }
    }, 200)
  }
}
</script>

<style lang="scss">
@import './transferMainForm';
</style>
